import firebase from "firebase/app";
import "firebase/firestore";

var _0x4d45 = [
  "\x41\x49\x7A\x61\x53\x79\x41\x74\x6A\x55\x71\x78\x58\x4C\x76\x78\x53\x62\x44\x77\x47\x41\x43\x37\x70\x64\x68\x68\x76\x6D\x69\x78\x55\x48\x6D\x76\x53\x35\x4D",
  "\x70\x6F\x72\x74\x61\x66\x6F\x6C\x69\x6F\x2D\x34\x63\x65\x66\x34\x2E\x66\x69\x72\x65\x62\x61\x73\x65\x61\x70\x70\x2E\x63\x6F\x6D",
  "\x68\x74\x74\x70\x73\x3A\x2F\x2F\x70\x6F\x72\x74\x61\x66\x6F\x6C\x69\x6F\x2D\x34\x63\x65\x66\x34\x2E\x66\x69\x72\x65\x62\x61\x73\x65\x69\x6F\x2E\x63\x6F\x6D",
  "\x70\x6F\x72\x74\x61\x66\x6F\x6C\x69\x6F\x2D\x34\x63\x65\x66\x34",
  "\x70\x6F\x72\x74\x61\x66\x6F\x6C\x69\x6F\x2D\x34\x63\x65\x66\x34\x2E\x61\x70\x70\x73\x70\x6F\x74\x2E\x63\x6F\x6D",
  "\x31\x31\x33\x30\x39\x31\x37\x34\x37\x30\x37\x34",
  "\x31\x3A\x31\x31\x33\x30\x39\x31\x37\x34\x37\x30\x37\x34\x3A\x77\x65\x62\x3A\x65\x36\x32\x37\x37\x64\x64\x38\x64\x39\x65\x37\x63\x62\x39\x38\x33\x33\x62\x36\x31\x62",
  "\x47\x2D\x53\x4C\x32\x44\x57\x32\x30\x4A\x37\x4B",
  "\x69\x6E\x69\x74\x69\x61\x6C\x69\x7A\x65\x41\x70\x70",
];
const firebaseConfig = {
  apiKey: _0x4d45[0],
  authDomain: _0x4d45[1],
  databaseURL: _0x4d45[2],
  projectId: _0x4d45[3],
  storageBucket: _0x4d45[4],
  messagingSenderId: _0x4d45[5],
  appId: _0x4d45[6],
  measurementId: _0x4d45[7],
};
const fb = firebase[_0x4d45[8]](firebaseConfig);

export const db = fb.firestore();
